import React from 'react'
import colors from '../utils/colors'
import { FormDashboardTextarea } from './dashboard-form'
import { Button } from './buttons'

const FormPopupContent = ({setSubmitted, ...props}) => {
  return (
    <div>
      <p className="text-lg lg:text-2xl font-bold mb-4 lg:mb-10">Add Your Testimony</p>
      <div className="text-gray-444 text-sm mb-5 lg:mb-8">
        <FormDashboardTextarea
          className="w-full"
        />
      </div>
      <div onClick={() => setSubmitted(true)} className="lg:inline-block">
        <Button className="hidden lg:inline-block lg:px-16">
          Submit
        </Button>
        <div className="lg:hidden">
          <Button thin>
            Submit
          </Button>
        </div>
      </div>
    </div>
  )
}

const ConfirmationContent = () => {
  return (
    <div>
      <p className="text-lg lg:text-2xl font-bold mb-5 lg:mb-10">Thank You</p>
      <p className="text-sm text-gray-444">Testimony dalam masa moderasi. Exercitation veniam consequat sunt nostrud amet. Deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.”</p>
    </div>
  )
}

const TestimoniAdder = () => {
  const [show, setShow] = React.useState(false)
  const [submitted, setSubmitted] = React.useState(false)

  const handleClose = (e) => {
    e.preventDefault()
    e.stopPropagation()

    setShow(false)
  }

  return (
    <div>
      <div
        className="block lg:inline-block rounded border-2 font-accent font-bold text-primary text-xs text-center lg:px-6 py-2 lg:py-4 cursor-pointer uppercase"
        style={{borderColor: colors.primary}}
        onClick={() => setShow(true)}
      >
        Submit Your Testimony
      </div>

      {/* Popup */}
      {
        show &&
        <div
          className="fixed left-0 top-0 w-full h-screen flex justify-center items-center"
          style={{zIndex: 900, background: 'rgba(0, 0, 0, 0.75)'}}
          onClick={handleClose}
        >
          <div className="container mx-auto" onClick={(e) => e.stopPropagation()}>
            <div className="lg:w-10/12 mx-auto p-5 lg:p-20 bg-white rounded overflow-y-auto" style={{maxHeight: '100vh'}}>

              {
                !submitted &&
                <FormPopupContent setSubmitted={setSubmitted}/>
              }

              {
                submitted &&
                <ConfirmationContent />
              }

            </div>
          </div>
        </div>
      }
    </div>
  )
}

export { TestimoniAdder }